export default __webpack_public_path__ + "static/media/portfolio-7.2282d3b6.jpg";